export default __webpack_public_path__ + "static/7-ca7a5c4068d54849d4851a5bc24b50f4.jpg";